import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useImposter } from 'Hooks';
import { Cake, NoImageAvatar } from 'Images';

export const User = () => {
  const { authenticatedUser, fakeUser } = useImposter();
  const isBirthday = false;
  return (
    <>
      <Stack gap='12px' alignItems='center'>
        <Avatar
          alt=''
          src={NoImageAvatar}
          sx={{ width: '44px', height: '44px' }}
        />
        {isBirthday ? (
          <Stack
            alignItems='center'
            justifyContent='center'
            p='16px 18px'
            bgcolor='purple2.shade_500'
          >
            <Avatar src={Cake} alt='' />
            <Typography
              variant='body2'
              textAlign='center'
              maxWidth='21ch'
              mt='9px'
            >
              {fakeUser.firstName || authenticatedUser.firstName}{' '}
              {fakeUser.lastName || authenticatedUser.lastName}
            </Typography>
            <Typography variant='body2' textAlign='center' maxWidth='21ch'>
              {Dictionary[DICTIONARY.General].sidebar.birthday}
            </Typography>
          </Stack>
        ) : (
          <Typography variant='body2'>
            {fakeUser.firstName || authenticatedUser.firstName}{' '}
            {fakeUser.lastName || authenticatedUser.lastName}
          </Typography>
        )}
      </Stack>
      {!isBirthday && <Divider aria-hidden='true' orientation='horizontal' />}
    </>
  );
};
